import { cn } from '../../lib/utils';

/**
 * An accessible on/off switch (the mobile-style toggle). Iris when on, a sliding
 * knob, keyboard- and screen-reader-friendly via `role="switch"`. Theme-aware.
 */
export function Toggle({
  checked,
  onChange,
  disabled,
  label,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  /** Accessible name when there's no visible <label> wired to it. */
  label?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-6 w-11 flex-none items-center rounded-full border transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-iris-strong',
        'focus-visible:ring-offset-2 focus-visible:ring-offset-obsidian',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'border-iris bg-iris' : 'border-border bg-surface-2',
      )}
    >
      <span
        className={cn(
          'inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform',
          checked ? 'translate-x-[22px]' : 'translate-x-0.5',
        )}
      />
    </button>
  );
}
